module.exports = __webpack_public_path__ + "static/media/4-item-a.5108aed9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/men/4-item-a.jpg
// module id = 1167
// module chunks = 33